<template>
  <b-form-group :label="label">
    <b-input-group prepend="$">
      <b-form-input
        :name="name"
        :data-cy="dataCy"
        ref="inputRef"
        :state="state"
        :disabled="disabled"
        :placeholder="placeholder"
      />
    </b-input-group>
    <div
      v-if="danger"
      class="con-text-validation span-text-validation-danger v-enter-to text-left"
    >
      <span class="span-text-validation">
        {{ dangerText }}
      </span>
    </div>
  </b-form-group>
</template>

<script>
import { watch } from '@vue/composition-api';
import { useCurrencyInput } from 'vue-currency-input';

export default {
  name: 'InputCurrency',
  data() {
    return {
      isInputActive: false
    };
  },
  props: {
    id: {
      type: String,
      requited: true
    },
    value: { type: [String, Number], default: '' },
    danger: { type: Boolean },
    dangerText: { type: String },
    placeholder: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'Monto'
    },
    state: {
      type: Boolean
    },
    disabled: { type: Boolean, required: false, default: false },
    clases: { type: String, required: false },
    name: { type: String, required: false },
    dataCy: { type: String, required: false },
    updateRef: { type: Function, default: () => {} },
    options: {
      type: Object,
      default: () => ({
        locale: 'es-CL',
        currency: 'SAR',
        hideGroupingSeparatorOnFocus: false,
        currencyDisplay: 'hidden',
        precision: {
          min: 0,
          max: 2
        }
      })
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event?.value);
    }
  },
  computed: {},
  setup(props) {
    const { inputRef, setValue } = useCurrencyInput(props.options);
    watch(
      () => props.value,
      (newVal) => {
        setValue(newVal);
      }
    );
    return { inputRef };
  }
};
</script>
<style>
.input-group:has(> .form-control.is-invalid) .input-group-prepend>.input-group-text {
  border: 1px solid red;
}
</style>
